import { Alert } from 'react-bootstrap';
import { setByLine } from '@/utils/clientFlags';
import { skipKind, skipLine, type GroupSkippedClient } from '@/utils/groupRunSkips';

/**
 * The clients a group run is about to skip, one line each with the reason,
 * shown in the confirm step before anything starts. Red when one of them is
 * marked do not deploy, amber otherwise. Nothing when no client is skipped.
 */
export function SkippedClientsNotice({
  skipped,
  className,
}: {
  skipped: readonly GroupSkippedClient[];
  className?: string;
}) {
  if (skipped.length === 0) return null;
  const blocked = skipped.some((s) => skipKind(s) === 'deploy-block');
  return (
    <Alert variant={blocked ? 'danger' : 'warning'} className={className}>
      {skipped.length === 1 ? '1 client is skipped:' : `${skipped.length} clients are skipped:`}
      <ul className="deploy-confirm__skipped">
        {skipped.map((s) => (
          <li key={s.clientName}>
            <strong>{s.clientName}</strong>: {skipLine(s)}{' '}
            {s.setBy && (
              <span className="deploy-confirm__skipped-who" title={s.setBy}>
                ({setByLine({ setBy: s.setBy, setAt: s.setAt ?? '' })})
              </span>
            )}
          </li>
        ))}
      </ul>
    </Alert>
  );
}

export default SkippedClientsNotice;
